// removed by extract-text-webpack-plugin
module.exports = {"root":"view-all-products-link--root--2M6Kbr87"};


//////////////////
// WEBPACK FOOTER
// ./components/view-all-products-link/styles.css
// module id = ./components/view-all-products-link/styles.css
// module chunks = 0